
import InputFieldMixin from '~/components/Inputs/_InputFieldMixin';
import TextInput from '~/components/Inputs/Text.vue';
import emailValidator from '~/validators/email_address';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'EmailInput',

  components: { TextInput },

  mixins: [InputFieldMixin],

  props: {
    showIcon: { type: Boolean, default: false },
  },

  data: () => ({
    defaultLabelAttr: 'Email',
    defaultDataTestAttr: 'emailInput',
  }),

  methods: {
    validateEmail(value: string): string | boolean {
      if (!value) return this.isRequired();

      if (!emailValidator(value)) return 'Please correct email format';

      return true;
    },
  },
});
